import { useLocation, useNavigate } from "react-router";
import { getBillingStatus } from "../services/customer-services/customerBillingStatus";
import { useEffect, useState } from "react";

const RequireAuth = ({ isCustomer, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      if (!isCustomer) {
        setAllowed(true);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const res = await getBillingStatus();

        if (!isMounted) return;

        const isPlanActive = res?.isPlanActive;

        const path = window.location.pathname;

        const isAllowedRoute =
          path.includes("/billing") || path.includes("/settings");

        if (!isPlanActive && !isAllowedRoute) {
          navigate("/billing/plans", { replace: true });
          return;
        }

        setAllowed(true);
      } catch (err) {
        console.error(err);
        setAllowed(false);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [isCustomer, location.pathname, navigate]);

  if (loading) return null; // or spinner

  if (!allowed) return null;

  return children;
};

export default RequireAuth;